
import TopSpacer from "../../../components/Common/spacer/TopSpacer";
import useStyles from './styles';
import Breadcrums from "../../../components/BreadCrums/breadcrums";
import { InputBase, Grid, Button } from "@material-ui/core";
import { useState } from "react";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import { useEffect } from "react";
import SearchGrid from "../../../components/table/SearchGrid";
import { PostDataAPI } from "../../../Services/APIService";
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import AddNewDonorDialog from "./component/addNewDonor";
import ViewDetail from "../organization/organizationDetails/viewDetail";
import { withSnackbar } from "../../../components/Message/Alert";
import Loader from "../../../components/Loader/Loader";

function Donor({ ...props }) {
    const classes = useStyles();

    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);

    const [editItem, setEditItem] = useState({});
    const [addNewDonorDialog, setAddNewDonorsDialog] = useState(false);
    const [searchFilter, setValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [donorBook, setDonorBook] = useState([]);
    const [isViewDetails, setIsViewDetails] = useState(false)

    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };
    const handleSearch = (e) => {
        debugger
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const [organizationId, setOrganizationId] = useState();

    const handleActionClick = (key, item) => {
        if (key == 'viewDetails') {
            setIsViewDetails(true)
            setOrganizationId(item.donorId)
        } else if (key == "delete") {
            deleteItem(item.donorId)
        } else if (key == 'edit') {
            setEditItem(item)
            setAddNewDonorsDialog(true)
        }
    }

    const closeDetails = () => {
        setIsViewDetails(false)
    }
    const { showMessage } = props;

    const handleSuccessClose = (message) => {
        setAddNewDonorsDialog(false);
        showMessage("Success", message, "success", 3000);
        loadDonorsBookGrid();
        setEditItem({});
    }



    const deleteItem = (id) => {
        let obj = {
            donorId: id
        }
        showActionDialog(
            "Are you sure you want to delete this record?",
            "confirm",
            function () {
                setIsLoading(true);

                PostDataAPI("fdngrantdonor/delete", obj).then((result) => {
                    if (result.success) {
                        showMessage("Success", "Donor deleted successfully", "success", 3000);
                        loadDonorsBookGrid();
                    } else {
                        showMessage("Error", result.message, "error", 3000);
                    }
                    setIsLoading(false);
                });
            }
        );
    };
    const addDonor = () => {
        setAddNewDonorsDialog(true)
    }
    const handleClose = () => {
        setAddNewDonorsDialog(false)
        setEditItem({});
    }


    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };


    const [donorData, setDonorData] = useState();

    const loadDonorsBookGrid = () => {
        setIsLoading(true);


        PostDataAPI("fdngrantdonor/loadGrid").then((result) => {
            if (result.success && result.data != null) {

                setDonorData(result.data);
                handleDataGridUpdate()
                setIsLoading(true);
            }
            else {
                setDonorData([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }



    useEffect(() => {
        loadDonorsBookGrid()
    }, []);
    return (
        <>
            <TopSpacer></TopSpacer>
            {isLoading ? <Loader></Loader> : ''}
            {isViewDetails ? <ViewDetail closeDetails={closeDetails} organizationId={organizationId} /> :

                <div>

                    <div className={classes.header}>

                        <Grid container alignItems="baseline">
                            <Grid item lg={12}>
                                <Breadcrums parentLink={"Donor"} isBack={true}></Breadcrums>
                            </Grid>
                        </Grid>
                    </div>

                    <Grid row className={classes.gridHeader}>
                        <div className={classes.gridActions}>
                            <Button className={classes.changeBtn} onClick={() => addDonor()}>
                                <AddCircleOutlineIcon style={{ marginRight: '6px' }} />Add New
                            </Button>
                        </div>
                        <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                            <InputBase
                                value={searchFilter}
                                placeholder="Search"
                                className="grid-search-input"
                                endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                                startAdornment={<SearchIcon />}
                                onChange={handleSearch}
                            />
                        </div>
                    </Grid>
                    <Grid className={classes.container}>
                        <SearchGrid
                            columns="donor"
                            list={donorData}
                            filter={searchFilter}
                            noRecordMsg="no record exists"
                            Icon={true}
                            isUpdate={isDataGridUpdate}
                            onActionClick={handleActionClick}
                        >
                        </SearchGrid>
                    </Grid>
                </div>
            }

            <AddNewDonorDialog
                isOpen={addNewDonorDialog}
                handleClose={handleClose}
                handleSuccessClose={handleSuccessClose}
                editItem={editItem}
            ></AddNewDonorDialog>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />


        </>
    )
}

export default withSnackbar(Donor);